module.exports = __webpack_public_path__ + "fonts/Timelapse.4bf3f0f3.eot";